/**
 * components/riskTerminal/UpstoxSignedIn.jsx
 *
 * upstox-053 — the app page the Upstox callback lands on when sign-in was
 * opened in a new tab (#upstox-signed-in). It announces the sign-in to the
 * terminal / Settings tabs and closes itself; a browser that refuses to
 * close it gets a plain "you can close this tab" in the app's styling.
 */

import React, { useEffect, useState } from 'react';
import { announceSignedIn } from './signin';

export default function UpstoxSignedIn() {
  const [stillOpen, setStillOpen] = useState(false);
  useEffect(() => {
    announceSignedIn();
    try { window.close(); } catch (e) { /* refused */ }
    const t = setTimeout(() => setStillOpen(true), 400);
    return () => clearTimeout(t);
  }, []);
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg, #f6f4ef)', fontFamily: 'var(--font-ui, "IBM Plex Sans", sans-serif)' }}>
      <div style={{ background: 'var(--surface, #fff)', border: '.5px solid var(--hair, #dbd6cb)', borderRadius: 10, padding: '24px 30px', maxWidth: 420, textAlign: 'center' }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--up-field-ink, #2e7d32)', marginBottom: 8 }}>Upstox</div>
        <div style={{ fontSize: 15, color: 'var(--ink, #1a1917)', fontWeight: 600, marginBottom: 6 }}>Signed in to Upstox</div>
        <div style={{ fontSize: 12, color: 'var(--ink-2, #3f3b35)' }}>
          {stillOpen ? 'You can close this tab — the terminal has already updated.' : 'Closing…'}
        </div>
      </div>
    </div>
  );
}
